export default "__VITE_ASSET__DwhjmOag__"